export default __webpack_public_path__ + "static/media/ABChanelCorpo-Light.25ad93e5.woff";